exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-layout[data-v-1e94ae9c]{min-height:calc(100vh - 92px);box-sizing:border-box;border:1px solid var(--border);border-radius:var(--radius);background-color:#fff;box-shadow:0 1px 2px rgba(16,24,40,.04)}.content-layout__header[data-v-1e94ae9c]{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:24px 32px;border-bottom:1px solid var(--border)}.content-layout__header__title[data-v-1e94ae9c]{margin:0;font-size:24px;line-height:32px}.content-layout__description[data-v-1e94ae9c]{max-width:720px;margin:4px 0 0;color:var(--text-muted);font-size:13px;line-height:1.6}.content-layout__actions[data-v-1e94ae9c]{display:flex;align-items:center;gap:12px;flex-shrink:0}.content-layout__body[data-v-1e94ae9c]{padding:24px 32px 32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e94ae9c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/content-layout.vue
// module id = 862
// module chunks = 0